export default __webpack_public_path__ + "static/media/two_green_mob.ccfb8e0a.svg";